import {inject, Injectable} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastService} from '../toast/toast-service';
import {QrCodeModalComponent} from './qr-code-modal.component';
import {downloadQrImage, renderQrDataUrl} from './qr-code.utils';

export interface QrCodeModalOptions {
  title: string;
  subtitle?: string;
  code: string | null | undefined;
  fileName?: string;
}

/** Opens {@link QrCodeModalComponent} with a rendered QR image, copy and download. */
@Injectable({providedIn: 'root'})
export class QrCodeModalService {
  private readonly modal = inject(NgbModal);
  private readonly toast = inject(ToastService);

  async open(options: QrCodeModalOptions): Promise<void> {
    const code = options.code?.trim() || '';
    const ref = this.modal.open(QrCodeModalComponent, {centered: true, size: 'md', scrollable: false});
    const instance = ref.componentInstance as QrCodeModalComponent;
    instance.title = options.title;
    instance.subtitle = options.subtitle ?? null;
    instance.qrCode = code || null;
    instance.canCopy = !!code;
    instance.canExport = !!code;
    instance.copyClicked.subscribe(() => this.copy(code));
    instance.exportClicked.subscribe(
      () => downloadQrImage(instance.qrImageUrl, options.fileName ?? code)
    );
    if (!code) {
      return;
    }
    instance.qrImageUrl = await renderQrDataUrl(code);
    instance.hasQrImage = !!instance.qrImageUrl;
  }

  private copy(code: string): void {
    if (!code || !navigator.clipboard) {
      return;
    }
    void navigator.clipboard.writeText(code).then(() => this.toast.success('คัดลอกรหัส QR แล้ว'));
  }
}
